import { useIntl } from "react-intl";
import { useState } from "react";
import { Modal } from "medere-ui-framework";
import { useDispatch } from 'react-redux';

interface NoHealthPatientCoverageModalProps {
    patientName:string;
    healthEntity:string;
    openNoHealthPatientCoverageModal: boolean;
    setOpenNoHealthPatientCoverageModal: (open: boolean) => void;
    setOpenHealthPatientCoverageModal:(value:boolean)=>void;
}

export default function NoHealthPatientCoverageModal({patientName, healthEntity, openNoHealthPatientCoverageModal, setOpenNoHealthPatientCoverageModal ,setOpenHealthPatientCoverageModal}: NoHealthPatientCoverageModalProps) {

  const dispatch = useDispatch();
  const intl = useIntl();
  const [isMobile] = useState(window.innerWidth <= 768);

  return (
    <Modal
      visible={openNoHealthPatientCoverageModal}
      setVisible={setOpenNoHealthPatientCoverageModal}
      className="nv-scope nv-dialog custom-modal w-auto"
      header={<span className="nv-modal-title">{`${patientName} no tiene una cobertura de ${healthEntity}`}</span>}
      footerButtonLeftText = {"No, volver atrás"}
      footerButtonRightText= {"Si, crear"}
      onClickLeftBtn={()=>setOpenNoHealthPatientCoverageModal(false)}
      onClickRightBtn={()=> {
        setOpenNoHealthPatientCoverageModal(false);
        setOpenHealthPatientCoverageModal(true);
      }}
      closable={false}
    >
      <div style={{ minWidth: isMobile ? "" : "150px" }}>
        <div className="flex flex-column gap-2">
          <span>{`¿Querés crear la cobertura ahora?`}</span>
        </div>
      </div>
    </Modal>
  );
}
